var map = {
	"./arg.svg": 2334,
	"./aus.svg": 2335,
	"./bel.svg": 2336,
	"./bra.svg": 2337,
	"./can.svg": 2338,
	"./cmr.svg": 2339,
	"./crc.svg": 2340,
	"./cro.svg": 2341,
	"./den.svg": 2342,
	"./ecu.svg": 2343,
	"./eng.svg": 2344,
	"./esp.svg": 2345,
	"./fra.svg": 2346,
	"./ger.svg": 2347,
	"./gha.svg": 2348,
	"./irn.svg": 2349,
	"./jpn.svg": 2350,
	"./kor.svg": 2351,
	"./ksa.svg": 2352,
	"./mar.svg": 2353,
	"./mex.svg": 2354,
	"./ned.svg": 2355,
	"./pol.svg": 2356,
	"./por.svg": 2357,
	"./qat.svg": 2358,
	"./sen.svg": 2359,
	"./srb.svg": 2360,
	"./sui.svg": 2361,
	"./tun.svg": 2362,
	"./uru.svg": 2363,
	"./usa.svg": 2364,
	"./wal.svg": 2365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;